import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'components.Review.title',
    defaultMessage: 'Review Your Order',
  },
  itemProductHeader: {
    id: 'shop.cart.columnTitleProduct',
    defaultMessage: 'Product',
  },
  itemPriceHeader: {
    id: 'shop.cart.columnTitlePrice',
    defaultMessage: 'Price',
  },
  itemQuantityHeader: {
    id: 'shop.cart.columnTitleQuantity',
    defaultMessage: '#',
  },
  itemTotalHeader: {
    id: 'shop.cart.columnTitleTotal',
    defaultMessage: 'Total',
  },
  subtotal: {
    id: 'shop.cart.subtotal',
    defaultMessage: 'Subtotal',
  },
  grandTotal: {
    id: 'shop.cart.grandTotal',
    defaultMessage: 'Order Total',
  },
  shippingHandling: {
    id: 'common.titles.shippingHandling',
    defaultMessage: 'Shipping & Handling',
  },
  continue: {
    id: 'common.buttons.continue',
    defaultMessage: 'Continue',
  },
  billingTitle: {
    id: 'common.titles.billingAddress',
    defaultMessage: 'Billing address',
  },
  shippingTitle: {
    id: 'common.titles.shippingAddress',
    defaultMessage: 'Shipping address',
  },
  shippingMethod: {
    id: 'common.titles.shippingMethod',
    defaultMessage: 'Shipping method',
  },
  backAddress: {
    id: 'components.Delivery.back',
    defaultMessage: 'Back to edit address',
  },
  backShipping: {
    id: 'components.Review.backShipping',
    defaultMessage: 'Back to shipping method',
  },
  discount: {
    id: 'shop.cart.discountLabel',
    defaultMessage: 'Discount',
  },
  appliedTax: {
    id: 'shop.cart.appliedTax',
    defaultMessage: 'Plus tax',
  },
  exTax: {
    id: 'shop.cart.ExTax',
    defaultMessage: 'Excl. Tax',
  },
  inclTax: {
    id: 'shop.cart.IncTax',
    defaultMessage: 'Incl. Tax',
  },
  termsError: {
    id: 'components.Review.termsError',
    defaultMessage: 'Please check all the checkboxes if you want to proceed.',
  },
  free: {
    id: 'components.success.freeShipping',
    defaultMessage: 'Free',
  },
  giftCard: {
    id: 'shop.cart.giftCard',
    defaultMessage: 'Gift Card',
  },
  content: {
    id: 'duplicateLicenseWarning.content',
    defaultMessage: 'You already own {product}',
  },
  returnToCart: {
    id: 'duplicateLicenseWarning.returnToCart',
    defaultMessage: 'Return to cart',
  },
  duplicateModalTitleSingle: {
    id: 'duplicate.modalSingle.title',
    defaultMessage: 'Duplicate product',
  },
  duplicateModalDescriptionSingle: {
    id: 'duplicate.modalSingle.content',
    defaultMessage:
      'We noticed that you already own {product}. Are you sure you want to proceed with this order?',
  },
  duplicateModalTitleMulti: {
    id: 'duplicate.modalMultiple.title',
    defaultMessage: 'Duplicate products',
  },
  duplicateModalDescriptionMulti: {
    id: 'duplicate.modalMultiple.content',
    defaultMessage:
      'We noticed that you already own several of these products. Are you sure you want to proceed with this order?',
  },
  wrongLicenseModalTitleSingle: {
    id: 'license.modalSingle.title',
    defaultMessage: 'Wrong license',
  },
  wrongLicenseModalTitleMulti: {
    id: 'license.modalMultiple.title',
    defaultMessage: 'Wrong licenses',
  },
  wrongLicenseModalContentSingle: {
    id: 'license.modalSingle.content',
    defaultMessage:
      'We noticed that you don’t qualify for a {product} license. Are you sure you want to proceed with this order?',
  },
  wrongLicenseModalContentMulti: {
    id: 'license.modalMultiple.content',
    defaultMessage:
      'We noticed that you don’t qualify for several of these licenses. Are you sure you want to proceed with this order?',
  },
  areYouSure: {
    id: 'duplicate.modalSingle.contentSecondLine',
    defaultMessage: 'Are you sure you want to proceed with this order?',
  },
  ownershipWarning: {
    id: 'components.ProductUpgradeMessage.ownershipWarning',
    defaultMessage:
      "You won't be able to install and activate this version unless you own one of the required products listed above!",
  },
});
